import axios, { type AxiosRequestConfig } from 'axios';
import { HttpClient } from './client';
const GLOBAL_DEFAULTS = {};

type TSetter = ( client: HttpClient ) => void;

interface IPlugin {
    register: ( client: HttpClient ) => void;
}

export class HttpClientBuilder {

    private readonly _config: AxiosRequestConfig;

    private readonly _setters: Array<( client: HttpClient ) => void>;

    private readonly _deferSetters: Array<( client: HttpClient ) => void>;

    private readonly _ctx: { globalDefaults: boolean; };

    public constructor( axiosRequestConfig = {}) {

        this._config = axiosRequestConfig;

        this._setters = [];

        this._deferSetters = [];

        this._ctx = {
            globalDefaults: true
        };

    }

    public disableGlobalDefaults(): this {

        this._ctx.globalDefaults = false;

        return this;

    }

    public clientSetter( setter: TSetter ): this | void {

        if ( typeof setter !== 'function' ) return;

        this._setters.push( setter );

        return this;

    }

    public clientDeferSetter( setter: TSetter ): this | void {

        if ( typeof setter !== 'function' ) return;

        this._deferSetters.push( setter );

        return this;

    }

    /**
     *
     * @param {} plugin
     */
    public usePlugin( plugin: IPlugin ): this {

        this._setters.push(( client ) => {

            plugin.register( client );

        });

        return this;

    }

    public buildClient(): HttpClient {

        const client = axios.create( this._config );

        const defaults = this._getDefaults();

        const httpClientInstance = new HttpClient( client, defaults );

        for ( const setter of this._setters ) {

            setter( httpClientInstance );

        }
        for ( const setter of this._deferSetters ) {

            setter( httpClientInstance );

        }

        return httpClientInstance;

    }

    private _getDefaults(): Record<string, any> {

        if ( this._ctx.globalDefaults ) {

            return GLOBAL_DEFAULTS;

        }
        return {};

    }

}
